import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";

export const TaxInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Tax Information</Text>
            </View>

            <View style={baseStyles.flexBetween}>
                <Text>Tax Rate</Text>
                <Text>{pdfData.tax_rate}%</Text>
            </View>

            {/*<View style={{...baseStyles.flexBetween}}>*/}
            {/*    <Text*/}
            {/*        style={{width: '40%', ...baseStyles.bold, ...baseStyles.alignEnd}}*/}
            {/*    >*/}
            {/*        Type*/}
            {/*    </Text>*/}
            {/*    <Text*/}
            {/*        style={{width: '25%', ...baseStyles.bold, ...baseStyles.alignEnd}}*/}
            {/*    >*/}
            {/*        Paid*/}
            {/*    </Text>*/}
            {/*    <Text*/}
            {/*        style={{width: '24%', ...baseStyles.bold, ...baseStyles.alignEnd}}*/}
            {/*    >*/}
            {/*        Rate*/}
            {/*    </Text>*/}
            {/*    <Text*/}
            {/*        style={{width: '10%', ...baseStyles.bold, ...baseStyles.alignEnd}}*/}
            {/*    >*/}
            {/*        Amt*/}
            {/*    </Text>*/}
            {/*</View>*/}
            {/*{*/}
            {/*    taxes.map((t) => {*/}
            {/*        return (*/}
            {/*            <View*/}
            {/*                key={t.Name}*/}
            {/*                style={{...baseStyles.flexBetween}}*/}
            {/*            >*/}
            {/*                <Text*/}
            {/*                    style={{ width: '50%'}}*/}
            {/*                >*/}
            {/*                    {t.Name}*/}
            {/*                </Text>*/}
            {/*                <Text*/}
            {/*                    style={{ width: '20%'}}*/}
            {/*                >*/}
            {/*                    {t.Type}*/}
            {/*                </Text>*/}
            {/*                <Text*/}
            {/*                    style={{ width: '20%'}}*/}
            {/*                >*/}
            {/*                    {t.TaxRate}*/}
            {/*                </Text>*/}
            {/*                <Text*/}
            {/*                    style={{ width: '10%'}}*/}
            {/*                >*/}
            {/*                    {t.Amount.toDollarFormat()}*/}
            {/*                </Text>*/}
            {/*           </View>*/}
            {/*        )*/}
            {/*    })*/}
            {/*}*/}
            {/*<View*/}
            {/*    style={{...baseStyles.flexBetween}}*/}
            {/*>*/}
            {/*    <Text*/}
            {/*        style={{ width: '50%'}}*/}
            {/*    >*/}
            {/*        Monthly Tax*/}
            {/*    </Text>*/}
            {/*    <Text*/}
            {/*        style={{ width: '20%'}}*/}
            {/*    >*/}
            {/*        Capped*/}
            {/*    </Text>*/}
            {/*    <Text*/}
            {/*        style={{ width: '20%'}}*/}
            {/*    >*/}
            {/*        { helper.taxRate() }*/}
            {/*    </Text>*/}
            {/*    <Text*/}
            {/*        style={{ width: '10%'}}*/}
            {/*    >*/}
            {/*        { helper.montlyUseTax().toDollarFormat() }*/}
            {/*    </Text>*/}
            {/*</View>*/}
        </View>
    )
}